module.exports = __webpack_public_path__ + "static/Laura-Gutierrez-6d135d77163089fb3154e17ce1104e7c.png";